import { PrepareBumpOrderResp } from 'types/api/response/prepare-bump-order-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const prepareBumpOrder = (
  itemIds: Array<number>,
  effectiveDays: number,
  international?: boolean,
) =>
  api.post<PrepareBumpOrderResp>(
    '/push_ups/orders',
    {
      item_ids: itemIds,
      effective_days: effectiveDays,
      international,
    },
    { headers: moneyObjectHeader },
  )
